const root = '/payments';

const mandates = `${root}/mandates`;

const transfers = `${root}/transfers`;

const scheduledTransfers = `${root}/scheduledTransfers`;

const scheduledTransferDetails = `${scheduledTransfers}/:scheduledTransferId`;

const getScheduledTransferDetailsRoute = (scheduledTransferId: string) =>
  scheduledTransferDetails.replace(':scheduledTransferId', scheduledTransferId);

export default {
  getScheduledTransferDetailsRoute,
  mandates,
  root,
  scheduledTransferDetails,
  scheduledTransfers,
  transfers,
} as const;
